module.exports = __webpack_public_path__ + "img/briefcase.f126d0ec.svg";